import React from 'react';

export const MeasureArea = () => (
    <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.46 27.37">
        <g>
            <rect width="6.26" height="6.26"/>
            <polygon points="26.18 0 26.18 3.48 24.93 3.48 24.93 0 22.31 0 22.31 1.84 21.06 1.84 21.06 0 18.43 0 18.43 3.48 17.18 3.48 17.18 0 14.55 0 14.55 1.84 13.3 1.84 13.3 0 10.68 0 10.68 3.48 9.43 3.48 9.43 0 7.6 0 7.6 6.26 26.21 6.26 26.21 9.76 27.46 9.76 27.46 0 26.18 0"/>
            <polygon points="6.26 7.51 0 7.51 0 8.79 3.48 8.79 3.48 10.04 0 10.04 0 12.67 1.84 12.67 1.84 13.92 0 13.92 0 16.54 3.48 16.54 3.48 17.79 0 17.79 0 20.42 1.84 20.42 1.84 21.67 0 21.67 0 24.29 3.48 24.29 3.48 25.54 0 25.54 0 27.37 9.76 27.37 9.76 26.12 6.26 26.12 6.26 7.51"/>
            <rect x="12.89" y="26.12" width="7.31" height="1.25"/>
            <polygon points="26.21 26.12 23.34 26.12 23.34 27.37 27.46 27.37 27.46 23.25 26.21 23.25 26.21 26.12"/>
            <rect x="26.21" y="12.88" width="1.25" height="7.27"/>
        </g>
    </svg>
);
